import Template_Admin_1Component from './Template_Admin_1/index.vue'
export default { 
    Name: "applications",
    Title: "页面布局框架",
    Value: [
        { Name: "Template_Admin_1",Component: Template_Admin_1Component }
    ]
}